import { render, staticRenderFns } from "./fireAlarmControlPanel.vue?vue&type=template&id=15b97020&scoped=true&"
import script from "./fireAlarmControlPanel.vue?vue&type=script&lang=js&"
export * from "./fireAlarmControlPanel.vue?vue&type=script&lang=js&"
import style0 from "./fireAlarmControlPanel.vue?vue&type=style&index=0&id=15b97020&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b97020",
  null
  
)

export default component.exports